/* eslint-disable */
export default {
  conferenceCall: 'Neuvottelupuhelu',
  onHold: 'Pidossa',
  ongoing: 'Käynnissä',
  unknown: 'Tuntematon',
  disconnected: 'Yhteys katkaistu',
  loading: 'Ladataan...',
  loadingTimeout: 'Lataus aikakatkaistiin.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
